<template>
  <div class="page">
    <div class="header-menu">
      <navBar v-model="objSave" @fnSave="Save"></navBar>
    </div>
    <div class="page-content">
      <div class="feedBack">
        <div class="feedBack-slider">
          <div class="feedBack-title" @click="Todemand">想要更多国际航班信息，快来填写你的需求吧！>></div>
        </div>
        <div class="feedBack-wrapper">
          <div class="feedBack-item">
            <div class="feedBack-item-title" style="padding:0.532rem 0 0.266rem 0">{{$t('system_feedback_feedback_fankuileixing')}}</div>
            <div class="feedbackType-item">
              <label class="ellipsis" :class="{ Active: filterConsumers(models.AdviseType, feedbackType.value) }" v-for="(feedbackType, index) in feedbackTypes" :for="feedbackType.label">
                <span>{{ feedbackType.label }}</span>
                <input type="radio" :value="feedbackType.value" :id="feedbackType.label" v-model="models.AdviseType" />
                <img v-if="filterConsumers(models.AdviseType, feedbackType.value)" src="/static/img/travellerSelect.png" />
              </label>
            </div>
            <div class="feedBack-item-title" style="padding:0.266rem 0 0.266rem 0">{{$t('system_feedback_feedback_fankuineirong')}}</div>
            <div class="feedBack-content">
              <textarea v-model="models.AdviseContent" :placeholder="$t('system_feedback_feedback_wltgwmdfwhzlwmwntgfw')"></textarea>
            </div>
            <div class="feedBack-img">
              <form ref="$form" action="/api/storage/upload" method="post" target="uploadform" enctype="multipart/form-data">
                <label :for="uploadFile">
                  <div class="feedBack-uploadFile" v-if="models.AdviseImg == ''">
                    <input :id="uploadFile" style="display:none" @change="fileupload" type="file" name="uploadFile" />
                    <img src="/static/img/updatedImg-icon.png" style="width:0.532rem;" />
                    <div style="height:0.532rem;line-height:0.532rem;padding-top:0.133rem">{{$t('system_feedback_feedback_shangchuanzhaopian')}}</div>
                  </div>
                  <img v-else style="width:1.729rem;" :src="models.AdviseImg" />
                </label>
              </form>
              <div style="padding-top: 0.930rem;">{{$t('system_feedback_feedback_shangchuantupianshuomingkeyigengfangbianwomenlijienindexuqiuo')}}</div>
            </div>
          </div>
          <div class="feedBack-item">
            <div class="feedBack-feedBackinfo-item">
              <div>
                <input :placeholder="$t('system_feedback_feedback_yibianwomengeininhuifu')" v-model="models.ContactPhone" />
              </div>
              <div>{{$t('system_feedback_feedback_shoujihao')}}</div>
              <div></div>
            </div>
          </div>
          <div class="feedBack-item">
            <div class="feedBack-feedBackinfo-item">
              <div>
                <input :placeholder="$t('system_feedback_feedback_qitalianxifangshiyouxiang')" v-model="models.OtherContact" />
              </div>
              <div style="font-size:0.372rem;color:#222">{{$t('system_feedback_feedback_qita')}}</div>
              <div></div>
            </div>
          </div>
        </div>
        <div class="feedBack-btn" @click="Save">{{$t('system_feedback_feedback_tijiao')}}</div>
      </div>
    </div>
    <iframe v-if="isIframe" ref="$iframe" name="uploadform" style="display:none;"></iframe>
  </div>
</template>
<style scoped>
  .header-menu header {
    background-color: #12a3ff;
  }

  .feedBack-slider {
    height: 1.4rem;
    background-image: url("/static/img/feedBackBg.jpg");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
  }

  .feedBack-title {
    height: 1.064rem;
    line-height: 1.064rem;
    position: absolute;
    bottom: 0;
    background-color: rgba(12, 3, 6, 0.3);
    left: 0;
    right: 0;
    color: #fff;
    padding-left: 0.372rem;
    font-size: 0.372rem;
  }

  .feedBack-item {
    background-color: #fff;
    padding: 0 0.372rem;
    margin-bottom: 0.266rem;
  }

  .feedBack-item-title {
    color: #333333;
    font-size: 0.372rem;
  }

  .feedbackType-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.266rem 0;
    border-top: 0.01rem solid #e3e3e3;
    border-bottom: 0.01rem solid #e3e3e3;
    box-sizing: border-box;
  }

  .feedbackType-item > label {
    position: relative;
    display: inline-block;
    width: 2.66rem;
    height: 1.064rem;
    line-height: 1.064rem;
    border: 0.01rem solid #e3e3e3;
    text-align: center;
    box-sizing: border-box;
    border-radius: 0.03rem;
    cursor: pointer;
  }

  .feedbackType-item img {
    width: 0.399rem;
    position: absolute;
    right: 0;
    bottom: 0;
  }

  .feedbackType-item input {
    display: none;
  }

  .feedbackType-item .Active {
    border: 0.01rem solid #12a3ff;
    box-sizing: border-box;
  }

  .feedBack-img {
    display: flex;
    align-content: center;
    justify-content: space-between;
    font-size: 0.345rem;
    color: #999;
    padding-bottom: 0.266rem;
  }

  .feedBack-feedBackinfo-item {
    position: relative;
    font-size: 0.372rem;
  }

  .feedBack-feedBackinfo-item > div {
    height: 1.197rem;
    line-height: 1.197rem;
  }

  .ticketDemand-customerInfo-wrapper span input {
    width: 0.665rem;
    height: 0.665rem;
    background-color: #f2f2f2;
    border: none;
    text-align: center;
    color: #12a3ff;
    border-radius: 0.106rem;
  }

  .feedBack-feedBackinfo-item > div:first-child {
    margin-left: 1.596rem;
    color: #a8b0bb;
  }

  .feedBack-feedBackinfo-item > div:nth-child(2) {
    position: absolute;
    top: 0;
    left: 0;
    width: 1.596rem;
    color: #333;
  }

  .feedBack-feedBackinfo-item > div:nth-child(3) {
    position: absolute;
    top: 0;
    right: 0;
    height: 1.197rem;
    line-height: 1.197rem;
  }

  .feedBack-feedBackinfo-item div > input {
    border: none;
    height: 100%;
    width: 100%;
    color: #a8b0bb;
    font-size: 0.372rem;
  }

  .feedBack-btn {
    margin: 0.665rem 0.372rem 0.93rem 0.372rem;
    height: 1.064rem;
    line-height: 1.064rem;
    background-color: #12a3ff;
    color: #fff;
    text-align: center;
    border-radius: 0.106rem;
    cursor: pointer;
  }

  .feedBack-uploadFile {
    width: 1.729rem;
    padding: 0.266rem 0 0.133rem 0;
    background-color: #f0f0f0;
    text-align: center;
    cursor: pointer;
  }

  .feedBack-content textarea {
    width: 100%;
    color: #999999;
    height: 1.197rem;
    font-size: 0.372rem;
    border: none;
  }
</style>
<script>
  import navBar from "../modules/navBar.vue";
  export default {
    name: "feedBack",
    data() {
      return {
        isIframe: false,
        objSave: {
          centerTitle: this.$root.$t('system_feedback_feedback_yijianfankui') ,
        },
        models: {
          AdviseID: "",
          AdviseType: this.$root.$t('system_feedback_feedback_shijuetiyan') ,
          AdviseContent: "",
          AdviseImg: "",
          ContactPhone: "",
          OtherContact: "",
          CreateTime: "",
        },
        feedbackTypes: [
          {
            label: this.$root.$t('system_feedback_feedback_shijuetiyan') ,
            value: this.$root.$t('system_feedback_feedback_shijuetiyan') ,
          },
          {
            label: this.$root.$t('system_feedback_feedback_caozuotiyan') ,
            value: this.$root.$t('system_feedback_feedback_caozuotiyan') ,
          },
          {
            label: this.$root.$t('system_feedback_feedback_qita') ,
            value: this.$root.$t('system_feedback_feedback_qita') ,
          },
        ],
      };
    },
    mounted() {
      let __self = this;
      __self.isIframe = true;
      //   $('.feedBack').after('<iframe ref="$iframe" name="uploadform" style="display:none;"></iframe>');
    },
    methods: {
      filterConsumers(value, type) {
        if (value == type) {
          return true;
        } else {
          return false;
        }
      },
      fileupload() {
        let __self = this;
        let form = __self.$refs.$form;
        form.submit();
        this.$root.$toast.success(this.$root.$t('system_feedback_feedback_zhengzaishangchuan') , "succ");
        __self.$refs.$iframe.onload = function() {
          var data = $(this)
            .contents()
            .find("body")
            .text();
          if (data && data != "") {
            // let result = '/api/side/Storage/Index/Image/' + data;
            __self.models.AdviseImg = data;
            this.$root.$toast.success(this.$root.$t('system_feedback_feedback_shangchuanchenggong') , "succ");
          } else {
            $utils.fail(this.$root.$t('system_feedback_feedback_shangchuanshibai') , "fail");
          }
        };
      },
      Todemand() {
        let __self = this;
        __self.$router.push({
          path: "/mall/flight/demand",
        });
      },
      Save() {
        let __self = this;
        if (__self.models.AdviseContent == "" && __self.models.AdviseImg == "") {
          return this.$root.$toast.fail(this.$root.$t('system_feedback_feedback_qingtianxienindebaoguiyijianhuoshangchuanzhaopian') );
        }
        __self.$api.adapter.saveAdviseInfo(__self.models).then(json => {
          if (json.isSucc) {
            this.$root.$toast.success(this.$root.$t('system_feedback_feedback_tijiaochenggongganxienindefankui') );
            __self.models = {
              AdviseID: "",
              AdviseType: this.$root.$t('system_feedback_feedback_shijuetiyan') ,
              AdviseContent: "",
              AdviseImg: "",
              ContactPhone: "",
              OtherContact: "",
              CreateTime: "",
            };
          }
        });
      },
    },
    components: {
      navBar,
    },
  };
</script>
